export default {"src":"/_next/static/media/jd-TeaLength.3ecf6198.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};